export const updateEntryPrices = (entry: {
  quantity: string
  unitPrice: string
  totalPrice: string
}, trigger: 'unit' | 'total' | undefined): {
  unitPrice: string,
  totalPrice: string,
} => {
  const currentQuantity = parseFloat(entry.quantity || '0');
  const updatedPrices = trigger === 'total'
    ? ({
      unitPrice: `${currentQuantity > 0
        ? (Math.round(((
          parseFloat(entry.totalPrice || '0') / currentQuantity
        ) + Number.EPSILON) * 100) / 100)
        : 0
      }`,
      totalPrice: entry.totalPrice,
    })
    : ({
      unitPrice: entry.unitPrice,
      totalPrice: `${(Math.round(((
        parseFloat(entry.unitPrice || '0') * currentQuantity
      ) + Number.EPSILON) * 100) / 100)}`,
    });
  return updatedPrices;
};
